

export default (function (href, basename) {
  if (typeof href === 'string') {
    return '' + (basename || '') + href;
  }

  var pathname = href.pathname,
      search = href.search;

  return '' + (basename || '') + pathname + (search || '');
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-little-router/es/util/stringify-href.js
// module id = 595
// module chunks = 0